import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';
import { MsalAuthConfig } from '../config/app-config.token';

export function buildMsalConfiguration(msal: MsalAuthConfig): Configuration {
  return {
    auth: {
      clientId: msal.clientId,
      authority: `https://login.microsoftonline.com/${msal.tenantId}`,
      redirectUri: msal.redirectUri || window.location.origin,
      postLogoutRedirectUri: msal.postLogoutRedirectUri || window.location.origin,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  };
}
